import { render } from "./FranceLuage.vue?vue&type=template&id=61665e8a&scoped=true"
import script from "./FranceLuage.vue?vue&type=script&lang=js"
export * from "./FranceLuage.vue?vue&type=script&lang=js"

import "./FranceLuage.vue?vue&type=style&index=0&id=61665e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61665e8a"]])

export default __exports__